import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M 6 2 C 3.7840006 2 2 3.7840252 2 6 L 2 18 C 2 20.216013 3.7840006 22 6 22 L 18 22 C 20.215997 22 22 20.216013 22 18 L 22 6 C 22 3.7840252 20.215997 2 18 2 L 6 2 z M 6 4 L 18 4 C 19.108 4 20 4.8920001 20 6 L 20 18 C 20 19.108 19.108 20 18 20 L 6 20 C 4.8920001 20 4 19.108 4 18 L 4 6 C 4 4.8920001 4.8920001 4 6 4 z" />,
  'CheckboxBlankOutlined'
);
